<template>
  <v-snackbar
    v-model="infobarStatus"
    :color="
      $store.state.infobar.type === 'error'
        ? 'error darken-3'
        : $store.state.infobar.type === 'success'
        ? 'success'
        : $store.state.infobar.type === 'info'
        ? 'info'
        : ''
    "
    right
  >
    <v-avatar>
      <v-icon dark>{{
        $store.state.infobar.type === "error"
          ? "error"
          : $store.state.infobar.type === "success"
          ? "check_circle"
          : $store.state.infobar.type === "info"
          ? "info"
          : ""
      }}</v-icon>
    </v-avatar>
    {{ $store.state.infobar.text }}
    <v-spacer></v-spacer>
  </v-snackbar>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {
    infobarStatus: {
      get() {
        return this.$store.state.infobarStatus;
      },
      set(value) {
        this.$store.dispatch("dispatchInfobarStatus", value);
        this.$store.dispatch("dispatchInfobar", {
          type: "",
          text: "",
        });
      },
    },
  },
};
</script>
